module.exports = __webpack_public_path__ + "static/media/kostel-celek-highlighted.ab70eaca.jpg";